import React, { useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";


const AddEditBank = ({ setIsLoading, isLoading, show, handleClose, addEditDialogData, formData, setFormData, handleSubmit }) => {

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const isAddMode = addEditDialogData?.callingFor?.toLowerCase() === "Add";

  const isButtonDisabled = useMemo(() => {
    const isBankNameEmpty = !formData.bankName?.trim();

    if (isAddMode) return isBankNameEmpty;

    // EDIT MODE: check if any field has changed
    const fieldsToCompare = [
      "bankName",
      "accountNumber",
      "ifscCode",
      "accountHolderName",
      "upiId",
      "upiAppName",
      "upiPhoneNumber"
      
    ];

    const hasChanged = fieldsToCompare.some((field) => {
      const original = addEditDialogData?.data?.[field] || "";
      const current = formData?.[field] || "";
      return original !== current;
    });

    return isBankNameEmpty || !hasChanged;
  }, [formData, addEditDialogData, isAddMode]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{addEditDialogData.dialogTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="d-flex flex-column gap-2" onSubmit={handleSubmit}>
          <Form.Control
            type="text"
            placeholder="Name of Bank *"
            name="bankName"
            value={formData.bankName}
            onChange={handleInputChange}
          />
          <Form.Control
            type="text"
            placeholder="Acc No."
            name="accountNumber"
            value={formData.accountNumber}
            onChange={handleInputChange}
          />
          <Form.Control
            type="text"
            placeholder="IFSC CODE"
            name="ifscCode"
            value={formData.ifscCode}
            onChange={handleInputChange}
          />
          <Form.Control
            type="text"
            placeholder="Name Of The Acc. Holder"
            name="accountHolderName"
            value={formData.accountHolderName}
            onChange={handleInputChange}
          />
          <Form.Control
            type="text"
            placeholder="UPI ID"
            name="upiId"
            value={formData.upiId}
            onChange={handleInputChange}
          />
          <Form.Control
            type="text"
            placeholder="UPI App Name"
            name="upiAppName"
            value={formData.upiAppName}
            onChange={handleInputChange}
          />
          <Form.Control
            type="text"
            placeholder="UPI Phone Number"
            name="upiPhoneNumber"
            value={formData.upiPhoneNumber}
            onChange={handleInputChange}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button style={{ backgroundColor: '#4682b4' }} onClick={handleSubmit}  disabled={isButtonDisabled}>
          {addEditDialogData?.callingFor} Bank
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(AddEditBank);